<template>
    <van-row type="flex" class="row" justify="center">
      <van-col span="9" v-for="(li, index) in list" :key="index">
           <common-link :item='li' :page="tablist"></common-link>

           <!-- <router-link v-if="li.LinkType==0" :to="{path:'detail',query:{id:li.LinkId,title:li.Title}}">
              <img :src="li.ImgUrl" alt="" class="row_icon">
              <div class="row_title">{{li.Title}}</div>
           </router-link>
           <router-link v-if="li.LinkType==1" :to="{path:'article',query:{id:li.LinkId,title:li.Title}}">
              <img :src="li.ImgUrl" alt="" class="row_icon">
              <div class="row_title">{{li.Title}}</div>
           </router-link>
           <router-link v-if="li.LinkType==2" :to="{path:'basisExperience',query:{id:li.LinkId,title:li.Title}}">
              <img :src="li.ImgUrl" alt="" class="row_icon">
              <div class="row_title">{{li.Title}}</div>
           </router-link> -->
      </van-col>
    </van-row>
</template>
<script>
import commonLink from './commonLink'
export default {
    data() {
      return {
        list:[],
        tablist:'tablist'
      }
    },
    props: ['tab'],
    components:{
      commonLink
    },
    watch:{
      tab:{
        handler(newName, oldName) {
          this.list=newName
        },
      deep: true,
      immediate: true
      }
    }
}
</script>

<style scoped lang="scss">
.row{
    width: 100%;
    margin-bottom: 1.5rem;
    
}
</style>




// WEBPACK FOOTER //
// src/components/tablist.vue